'use client'

import { useTranslations } from 'next-intl'
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share'
import { Tooltip } from '@/components/elementary/Tooltip'
import { Facebook } from '@/components/icons/social/Facebook'
import { LinkedIn } from '@/components/icons/social/LinkedIn'
import { Twitter } from '@/components/icons/social/Twitter'
import { CopyContent } from '@/components/page-builder/blog/CopyContent'
import { getOriginUrl } from '@/lib/general-helpers'
import { removeHtmlTags } from '@/lib/html'
import { ARTICLE_SHARE_ICONS_TEST_IDS } from '@/lib/test-ids'

export function ShareIcons({ title, url }: { title: string; url: string }) {
	const isAbsoluteHttp = /^https?:\/\//i.test(url)

	const shareUrl = getShareUrl(url, isAbsoluteHttp)

	function getShareUrl(url: string, isAbsoluteHttp: boolean) {
		if (!url) {
			return getCurrentUrl()
		}
		return isAbsoluteHttp ? url : new URL(url, getOriginUrl()).toString()
	}

	function getCurrentUrl() {
		if (typeof window !== 'undefined') {
			return window.location.href
		}
		return getOriginUrl()
	}

	const t = useTranslations('blog')
	const commonClassnames = 'text-neutral-light-alpha-500'

	return (
		<div className="flex items-center gap-3" data-test-id={ARTICLE_SHARE_ICONS_TEST_IDS.COMPONENT}>
			{shareIconsMap.map(({ icon: Icon, tooltip, component: Component }) => (
				<Tooltip key={tooltip} content={t(tooltip)} asChild>
					<Component url={shareUrl} title={removeHtmlTags(title)} aria-label={t(tooltip)}>
						<Icon className={commonClassnames} />
					</Component>
				</Tooltip>
			))}
			<CopyContent shareUrl={shareUrl} />
		</div>
	)
}

const shareIconsMap = [
	{
		icon: Twitter,
		tooltip: 'shareOnTwitter' as const,
		component: TwitterShareButton,
	},
	{
		icon: Facebook,
		tooltip: 'shareOnFacebook' as const,
		component: FacebookShareButton,
	},
	{
		icon: LinkedIn,
		tooltip: 'shareOnLinkedIn' as const,
		component: LinkedinShareButton,
	},
] as const
